<template>
    <div>
        <router-link v-if="!external" class="brand-logo" :class="{'vertical-align' : vertical}" v-bind:to="{path: path}" />
        <a v-if="external" :href="path" class="brand-logo" target="_blank" ></a>
    </div>
</template>

<script>
    export default {
        name: 'Logo',
        props: {
            path : {
                type: String,
                default: '/'
            },
            vertical : {
                type: Boolean,
                default: false
            },
            external : {
                type: Boolean,
                default: false
            }
        }
    };
</script>

<style scoped>
    
</style>